var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("header", { class: { "header--tall": _vm.isTall } }, [
    _vm.isShowPartnerBanner && _vm.$config.partnerSiteBanner
      ? _c("section", { staticClass: "partner-banner nav-bar" }, [
          _c("div", { staticClass: "nav-bar__inner" }, [
            _c(
              "a",
              {
                attrs: {
                  target: "_blank",
                  href: _vm.$config.partnerSiteBanner.siteUrl
                }
              },
              [
                _vm.partnerLogoMobile
                  ? _c("img", {
                      class: {
                        "fx-hidden--medium fx-hidden--large fx-hidden--full":
                          _vm.partnerLogoDesktop
                      },
                      style: _vm.partnerLogoMobile.overrideStyles,
                      attrs: {
                        alt: _vm.partnerLogoMobile.alt,
                        src: _vm.partnerLogoMobile.url
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.partnerLogoDesktop
                  ? _c("img", {
                      class: { "fx-hidden--small": _vm.partnerLogoMobile },
                      style: _vm.partnerLogoDesktop.overrideStyles,
                      attrs: {
                        alt: _vm.partnerLogoDesktop.alt,
                        src: _vm.partnerLogoDesktop.url
                      }
                    })
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _c(
              "p",
              { staticClass: "partner-banner__copy" },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$config.partnerSiteBanner.message) +
                    "\n                    "
                ),
                _vm.$config.partnerLegal
                  ? _c(
                      "router-link",
                      {
                        staticClass: "partner-banner__legal",
                        attrs: {
                          to: {
                            query: _vm.updateQueryParams(_vm.$route.query, {
                              modal: "partner-legal"
                            })
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                            Learn more\n                    "
                        )
                      ]
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("section", { staticClass: "nav-bar" }, [
      _c(
        "div",
        {
          staticClass: "nav-bar__inner",
          class: { "nav-bar__inner--fluid": _vm.isFluid }
        },
        [
          _c(
            "div",
            {
              staticClass: "nav-bar__logo-container",
              class: {
                "nav-bar__logo-container--tab": _vm.hasLogoTab,
                "fx-hidden--small fx-hidden--medium": _vm.isFluid
              }
            },
            [
              _c(
                "router-link",
                {
                  staticClass: "nav-bar__logo",
                  attrs: {
                    to: _vm.$store.state.selectedLocation
                      ? _vm.fixPath(
                          "/?lat=" +
                            _vm.$store.state.selectedLocation.latitude +
                            "&lon=" +
                            _vm.$store.state.selectedLocation.longitude +
                            "&location_id=" +
                            _vm.$store.state.selectedLocation.id
                        )
                      : { name: "home" }
                  },
                  nativeOn: {
                    click: function($event) {
                      return _vm.onClickLogo($event)
                    }
                  }
                },
                [
                  _vm.logoMobile
                    ? _c("img", {
                        class: {
                          "fx-hidden--medium fx-hidden--large fx-hidden--full":
                            _vm.logoDesktop
                        },
                        style: _vm.logoMobile.overrideStyles,
                        attrs: {
                          "data-e2e": "site-header.logo",
                          alt: _vm.logoMobile.alt,
                          src: _vm.logoMobile.url
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.logoDesktop
                    ? _c("img", {
                        class: { "fx-hidden--small": _vm.logoMobile },
                        style: _vm.logoDesktop.overrideStyles,
                        attrs: {
                          "data-e2e": "site-header.logo",
                          alt: _vm.logoDesktop.alt,
                          src: _vm.logoDesktop.url
                        }
                      })
                    : _vm._e()
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.event
            ? _c(
                "button",
                {
                  staticClass: "fx-hidden--large fx-hidden--full nav-bar__back",
                  class: { "fx-hidden--small fx-hidden--medium": !_vm.isFluid },
                  attrs: { type: "button" },
                  on: { click: _vm.onClickBackButton }
                },
                [
                  _c("i", {
                    staticClass: "icon-chevron-lg-left nav-bar__back-icon"
                  })
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.event && !_vm.isExclusiveEvent
            ? _c(
                "div",
                {
                  staticClass: "event-information",
                  attrs: { "data-e2e": "event-information" }
                },
                [
                  _c("div", { staticClass: "event-title-container" }, [
                    _c("h1", { staticClass: "event-title" }, [
                      _vm._v(_vm._s(_vm.event.name))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "event-details" }, [
                    _vm.event.is_date_tbd
                      ? _c("span", [_vm._v("Date TBD")])
                      : _vm.event.is_time_tbd
                      ? _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("date")(_vm.event.local_date, "ddd, MMM D")
                            ) + ", Time TBD"
                          )
                        ])
                      : _vm.showYear
                      ? _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("date")(_vm.event.local_date, "ddd, MMM D")
                            ) +
                              ", " +
                              _vm._s(
                                _vm._f("date")(_vm.event.local_date, "YYYY")
                              )
                          )
                        ])
                      : _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("date")(_vm.event.local_date, "ddd, MMM D")
                            )
                          )
                        ]),
                    _vm._v(" "),
                    !_vm.event.is_time_tbd
                      ? _c("span", [
                          _vm._v(
                            " at " +
                              _vm._s(
                                _vm._f("date")(_vm.event.local_date, "h:mma")
                              )
                          )
                        ])
                      : _vm._e(),
                    _vm._v(
                      " -\n                        " +
                        _vm._s(_vm.event.venue.name) +
                        ",\n                        " +
                        _vm._s(_vm.event.venue.city_name) +
                        "\n                        " +
                        _vm._s(_vm.event.venue.subdivision) +
                        "\n                    "
                    )
                  ])
                ]
              )
            : _vm.isShowMenu
            ? _c(
                "nav",
                {
                  staticClass:
                    "primary-nav fx-hidden--small fx-hidden--medium fx-hidden--large"
                },
                [
                  _c(
                    "ul",
                    { staticClass: "primary-nav__list" },
                    _vm._l(_vm.highlights, function(category) {
                      return _c(
                        "li",
                        {
                          key: category.name,
                          staticClass: "primary-nav__item",
                          class: {
                            "primary-nav__item--active":
                              _vm.activeCategory === category
                          },
                          attrs: { "data-e2e": "site-header.category" }
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "primary-nav__item-button",
                              attrs: { type: "button" },
                              on: {
                                click: _vm.onClickNavigationCategory,
                                keypress: function($event) {
                                  if (
                                    !("button" in $event) &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  $event.preventDefault()
                                  _vm.onCategoryButtonPressEnter(category)
                                },
                                mouseout: _vm.onPrimaryNavMouseOver,
                                mouseover: function($event) {
                                  _vm.setExpandNavTimeout(category)
                                }
                              }
                            },
                            [_vm._v(_vm._s(category.name))]
                          )
                        ]
                      )
                    })
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "nav-bar__right",
              class: { "nav-bar__right--fluid": _vm.isFluid }
            },
            [
              _vm.isShowSearch && !_vm.hasBigSearch
                ? _c(
                    "section",
                    {
                      staticClass: "inline-search",
                      class: {
                        "fx-hidden--small fx-hidden--medium": _vm.isFluid
                      }
                    },
                    [
                      _c(
                        "form",
                        {
                          attrs: { "data-e2e": "home.search-form-inline" },
                          on: {
                            submit: function($event) {
                              $event.preventDefault()
                              return _vm.onSearch($event)
                            },
                            keyup: [
                              function($event) {
                                if (
                                  !("button" in $event) &&
                                  _vm._k(
                                    $event.keyCode,
                                    "down",
                                    40,
                                    $event.key,
                                    ["Down", "ArrowDown"]
                                  )
                                ) {
                                  return null
                                }
                                return _vm.onIncrementHighlightedSuggestionIndex(
                                  $event
                                )
                              },
                              function($event) {
                                if (
                                  !("button" in $event) &&
                                  _vm._k($event.keyCode, "up", 38, $event.key, [
                                    "Up",
                                    "ArrowUp"
                                  ])
                                ) {
                                  return null
                                }
                                return _vm.onDecrementHighlightedSuggestionIndex(
                                  $event
                                )
                              }
                            ]
                          }
                        },
                        [
                          _c("span", { staticClass: "icon icon-magnify" }),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "on-click-outside",
                                rawName: "v-on-click-outside",
                                value: _vm.hideSearchSuggestions,
                                expression: "hideSearchSuggestions"
                              }
                            ],
                            ref: "searchInput",
                            staticClass: "inline-search__input",
                            attrs: {
                              autocomplete: "true",
                              type: "search",
                              placeholder: "Search"
                            },
                            on: {
                              focus: _vm.showSearchSuggestions,
                              input: _vm.onSearchInput
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _vm.isShowSuggestions
                        ? _c("inline-search-suggestions", {
                            attrs: {
                              "highlighted-suggestion":
                                _vm.highlightedSuggestion,
                              "make-entity-route": _vm.makeEntityRoute,
                              "on-suggestion-click": _vm.onSuggestionClick,
                              suggestions: _vm.suggestions
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "event",
                                fn: function(ref) {
                                  var event = ref.event
                                  return _c("div", {}, [
                                    _c(
                                      "h4",
                                      {
                                        staticClass:
                                          "inline-search__suggestion-primary"
                                      },
                                      [_vm._v(_vm._s(event.name))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "h5",
                                      {
                                        staticClass:
                                          "inline-search__suggestion-secondary"
                                      },
                                      [
                                        event.is_date_tbd
                                          ? [_vm._v("Date TBD")]
                                          : event.is_time_tbd
                                          ? [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("date")(
                                                    event.local_date,
                                                    "ddd, MMM D"
                                                  )
                                                ) + ", Time TBD"
                                              )
                                            ]
                                          : [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("date")(
                                                    event.local_date,
                                                    "ddd, MMM D, h:mma"
                                                  )
                                                )
                                              )
                                            ],
                                        _vm._v(
                                          "\n                                    – " +
                                            _vm._s(event.venue)
                                        ),
                                        event.city
                                          ? [_vm._v(", " + _vm._s(event.city))]
                                          : _vm._e(),
                                        event.region
                                          ? [
                                              _vm._v(
                                                ", " + _vm._s(event.region)
                                              )
                                            ]
                                          : _vm._e()
                                      ],
                                      2
                                    )
                                  ])
                                }
                              },
                              {
                                key: "performer",
                                fn: function(ref) {
                                  var performer = ref.performer
                                  return _c("div", {}, [
                                    _c(
                                      "h4",
                                      {
                                        staticClass:
                                          "inline-search__suggestion-primary"
                                      },
                                      [_vm._v(_vm._s(performer.name))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "h5",
                                      {
                                        staticClass:
                                          "inline-search__suggestion-secondary"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            performer.count +
                                              " " +
                                              (performer.count === 1
                                                ? "event"
                                                : "events")
                                          )
                                        )
                                      ]
                                    )
                                  ])
                                }
                              },
                              {
                                key: "venue",
                                fn: function(ref) {
                                  var venue = ref.venue
                                  return _c("div", {}, [
                                    _c(
                                      "h4",
                                      {
                                        staticClass:
                                          "inline-search__suggestion-primary"
                                      },
                                      [_vm._v(_vm._s(venue.name))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "h5",
                                      {
                                        staticClass:
                                          "inline-search__suggestion-secondary"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            venue.count +
                                              " " +
                                              (venue.count === 1
                                                ? "event"
                                                : "events")
                                          )
                                        )
                                      ]
                                    )
                                  ])
                                }
                              },
                              {
                                key: "city",
                                fn: function(ref) {
                                  var city = ref.city
                                  return _c("div", {}, [
                                    _c(
                                      "h4",
                                      {
                                        staticClass:
                                          "inline-search__suggestion-primary"
                                      },
                                      [_vm._v(_vm._s(city.name))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "h5",
                                      {
                                        staticClass:
                                          "inline-search__suggestion-secondary"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            city.count +
                                              " " +
                                              (city.count === 1
                                                ? "event"
                                                : "events")
                                          )
                                        )
                                      ]
                                    )
                                  ])
                                }
                              }
                            ])
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.userProfile
                ? _c("div", { staticClass: "account" }, [
                    _c(
                      "button",
                      {
                        staticClass:
                          "account__welcome account__welcome--button",
                        class: {
                          "has-credit-card": _vm.creditCardType && _vm.lastFour
                        },
                        attrs: { type: "button" },
                        on: { click: _vm.toggleAccountMenu }
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass:
                              "account__welcome-inner fx-hidden--small fx-hidden--medium account__welcome-inner--expandable"
                          },
                          [
                            _vm._t("welcome", [
                              _vm._v(
                                "Welcome, " + _vm._s(_vm.userProfile.first_name)
                              )
                            ]),
                            _vm._v(" "),
                            _vm.hasMyAccountButton ||
                            _vm.hasMyTicketsButton ||
                            _vm.hasLogout
                              ? _c("span", {
                                  staticClass: "account__welcome-icon",
                                  class: {
                                    "icon-chevron-lg-up": _vm.isAccountMenuOpen,
                                    "icon-chevron-lg-down": !_vm.isAccountMenuOpen
                                  }
                                })
                              : _vm._e()
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass:
                              "account__welcome-inner fx-hidden--large fx-hidden--full account__welcome-inner--expandable"
                          },
                          [
                            _c("span", { staticClass: "icon-profile" }),
                            _vm._v(" "),
                            _c("span", {
                              staticClass: "account__welcome-icon",
                              class: {
                                "icon-chevron-lg-up": _vm.isAccountMenuOpen,
                                "icon-chevron-lg-down": !_vm.isAccountMenuOpen,
                                "no-credit-card--mobile":
                                  !_vm.creditCardType && !_vm.lastFour
                              }
                            })
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm.isAccountMenuOpen
                      ? _c(
                          "ul",
                          {
                            directives: [
                              {
                                name: "on-click-outside",
                                rawName: "v-on-click-outside",
                                value: _vm.closeAccountMenu,
                                expression: "closeAccountMenu"
                              }
                            ],
                            staticClass: "account__menu"
                          },
                          [
                            _c(
                              "li",
                              {
                                staticClass:
                                  "account__menu-item fx-hidden--large fx-hidden--full"
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "account__menu-item--welcome"
                                  },
                                  [
                                    _vm._v(
                                      "Welcome, " +
                                        _vm._s(_vm.userProfile.first_name)
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.$store.state.loyalty
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "account_menu-item--user-info"
                                      },
                                      [
                                        _vm.creditCardType && _vm.lastFour
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "user-info__credit-card"
                                              },
                                              [
                                                _vm.creditCardType
                                                  ? _c("img", {
                                                      staticClass:
                                                        "account__menu-item--credit-cards__icon",
                                                      attrs: {
                                                        alt:
                                                          _vm.creditCardType
                                                            .displayName,
                                                        src:
                                                          _vm.$store.state
                                                            .imagesCdn +
                                                          _vm.creditCardType
                                                            .iconSlug
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "user-info__middot"
                                                  },
                                                  [_vm._v("····")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "user-info__last-four"
                                                  },
                                                  [_vm._v(_vm._s(_vm.lastFour))]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "user-info__pipe"
                                                  },
                                                  [_vm._v("|")]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "user-info__loyalty-balance"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.formatPoints(
                                                  _vm.$store.state.loyalty
                                                    .balance
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "account__menu-close",
                                    attrs: { type: "button" },
                                    on: { click: _vm.closeAccountMenu }
                                  },
                                  [
                                    _c("span", {
                                      staticClass:
                                        "icon-close account__menu-close-icon"
                                    })
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.hasMyAccountButton
                              ? _c(
                                  "li",
                                  { staticClass: "account__menu-item" },
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        staticClass: "account__menu-action",
                                        attrs: { to: { name: "account" } },
                                        nativeOn: {
                                          click: function($event) {
                                            return _vm.closeAccountMenu($event)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "My Account\n                                        "
                                        ),
                                        _c("span", {
                                          staticClass:
                                            "icon-chevron-lg-right fx-hidden--full fx-hidden--large"
                                        })
                                      ]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.hasMyTicketsButton
                              ? _c(
                                  "li",
                                  { staticClass: "account__menu-item" },
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        staticClass: "account__menu-action",
                                        attrs: {
                                          to: { name: "purchases-upcoming" }
                                        },
                                        nativeOn: {
                                          click: function($event) {
                                            return _vm.closeAccountMenu($event)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "My Tickets\n                                        "
                                        ),
                                        _c("span", {
                                          staticClass:
                                            "icon-chevron-lg-right fx-hidden--full fx-hidden--large"
                                        })
                                      ]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.hasLogout
                              ? _c(
                                  "li",
                                  { staticClass: "account__menu-item" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "account__menu-action",
                                        on: { click: _vm.logout }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            (_vm.$config.auth || {})
                                              .logoutOverrideText || "Logout"
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      : _vm._e()
                  ])
                : _vm.hasLoginButton
                ? _c(
                    "router-link",
                    {
                      staticClass: "sign-in-button",
                      attrs: {
                        replace: "",
                        to: {
                          name: _vm.$route.name,
                          query: _vm.updateQueryParams(_vm.$route.query, {
                            modal: "login"
                          })
                        }
                      },
                      nativeOn: {
                        click: function($event) {
                          return _vm.onClickLogin($event)
                        }
                      }
                    },
                    [
                      _c("span", { staticClass: "icon--large icon-signin" }),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "fx-hidden--small fx-hidden--medium" },
                        [_vm._v("Sign in")]
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      (_vm.subcategories.length || _vm.results.length) && !this.isWindowSmall
        ? _c(
            "section",
            {
              directives: [
                {
                  name: "on-click-outside",
                  rawName: "v-on-click-outside",
                  value: _vm.onClickOutsideSubnav,
                  expression: "onClickOutsideSubnav"
                }
              ],
              staticClass: "subnav",
              on: {
                mouseout: _vm.setCollapseNavTimeout,
                mouseover: _vm.clearCollapseNavTimeout
              }
            },
            [
              _c("div", { staticClass: "subnav__inner" }, [
                _vm.subcategories.length > 0
                  ? _c(
                      "ul",
                      { ref: "subnavLeft", staticClass: "subnav__nav-left" },
                      _vm._l(_vm.subcategories, function(subcategory) {
                        return _c(
                          "li",
                          {
                            key: subcategory.name,
                            staticClass: "subnav__nav-left-item",
                            class: {
                              "subnav__nav-left-item--active":
                                _vm.activeSubcategory === subcategory
                            },
                            on: {
                              keyup: function($event) {
                                if (
                                  !("button" in $event) &&
                                  _vm._k(
                                    $event.keyCode,
                                    "right",
                                    39,
                                    $event.key,
                                    ["Right", "ArrowRight"]
                                  )
                                ) {
                                  return null
                                }
                                if ("button" in $event && $event.button !== 2) {
                                  return null
                                }
                                return _vm.addFocusToFirstRightNavItem($event)
                              },
                              mouseover: function($event) {
                                _vm.setActiveSubcategory(subcategory)
                              }
                            }
                          },
                          [
                            subcategory.slug
                              ? _c(
                                  "router-link",
                                  {
                                    staticClass: "subnav__nav-left-text",
                                    attrs: {
                                      to: _vm.$store.state.selectedLocation
                                        ? _vm.fixPath(
                                            subcategory.slug +
                                              "?lat=" +
                                              _vm.$store.state.selectedLocation
                                                .latitude +
                                              "&lon=" +
                                              _vm.$store.state.selectedLocation
                                                .longitude +
                                              "&location_id=" +
                                              _vm.$store.state.selectedLocation
                                                .id
                                          )
                                        : _vm.fixPath(subcategory.slug)
                                    },
                                    nativeOn: {
                                      click: function($event) {
                                        _vm.setActiveCategory(null)
                                      },
                                      focus: function($event) {
                                        _vm.setActiveSubcategory(subcategory)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(subcategory.name))]
                                )
                              : _c(
                                  "span",
                                  { staticClass: "subnav__nav-left-text" },
                                  [_vm._v(_vm._s(subcategory.name))]
                                )
                          ],
                          1
                        )
                      })
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "ul",
                  {
                    ref: "subnavRight",
                    staticClass: "subnav__nav-right",
                    class: {
                      "subnav__nav-right--exclusive":
                        _vm.activeCategory &&
                        _vm.activeCategory.id === "exclusive"
                    }
                  },
                  _vm._l(_vm.results, function(result) {
                    return _c(
                      "li",
                      {
                        key: result.name,
                        staticClass: "subnav__nav-right-item",
                        on: {
                          click: function($event) {
                            _vm.onClickPerformer(result.name)
                          },
                          keyup: function($event) {
                            if (
                              !("button" in $event) &&
                              _vm._k($event.keyCode, "left", 37, $event.key, [
                                "Left",
                                "ArrowLeft"
                              ])
                            ) {
                              return null
                            }
                            if ("button" in $event && $event.button !== 0) {
                              return null
                            }
                            return _vm.addFocusToActiveSubcategory($event)
                          }
                        }
                      },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "subnav__nav-right-link",
                            class: {
                              "subnav__nav-see-all":
                                result.slug === "/exclusive-events"
                            },
                            attrs: {
                              to: _vm.$store.state.selectedLocation
                                ? _vm.fixPath(
                                    result.slug +
                                      "?lat=" +
                                      _vm.$store.state.selectedLocation
                                        .latitude +
                                      "&lon=" +
                                      _vm.$store.state.selectedLocation
                                        .longitude +
                                      "&location_id=" +
                                      _vm.$store.state.selectedLocation.id
                                  )
                                : _vm.fixPath(result.slug)
                            },
                            nativeOn: {
                              click: function($event) {
                                _vm.setActiveCategory(null)
                              }
                            }
                          },
                          [_vm._v(_vm._s(result.name))]
                        )
                      ],
                      1
                    )
                  })
                )
              ])
            ]
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _vm.isShowPageNotFound
      ? _c("section", { staticClass: "not-found" }, [
          _c("h1", [_vm._v("Nothing to see here.")]),
          _vm._v(" "),
          _vm._m(0)
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isShowSearch && _vm.hasBigSearch
      ? _c(
          "section",
          { staticClass: "search" },
          [
            _c(
              "form",
              {
                staticClass: "search__form",
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.onSearch($event)
                  },
                  keyup: [
                    function($event) {
                      if (
                        !("button" in $event) &&
                        _vm._k($event.keyCode, "down", 40, $event.key, [
                          "Down",
                          "ArrowDown"
                        ])
                      ) {
                        return null
                      }
                      return _vm.onIncrementHighlightedSuggestionIndex($event)
                    },
                    function($event) {
                      if (
                        !("button" in $event) &&
                        _vm._k($event.keyCode, "up", 38, $event.key, [
                          "Up",
                          "ArrowUp"
                        ])
                      ) {
                        return null
                      }
                      return _vm.onDecrementHighlightedSuggestionIndex($event)
                    }
                  ]
                }
              },
              [
                _c("div", { staticClass: "search__form-inner" }, [
                  _c("span", { staticClass: "search-icon icon-magnify" }),
                  _vm._v(" "),
                  _c("input", {
                    ref: "searchInput",
                    staticClass: "search__input",
                    attrs: {
                      autocomplete: "true",
                      autofocus: "",
                      placeholder: _vm.isWindowSmall
                        ? "Search for a team, artist or venue"
                        : "Search your favorite team, artist or venue",
                      type: !_vm.isWindowSmall ? "search" : null
                    },
                    on: { click: _vm.onOpenMobileNav, input: _vm.onSearchInput }
                  }),
                  _vm._v(" "),
                  _vm.isShowSearchClose && _vm.isWindowSmall
                    ? _c("span", {
                        staticClass: "icon-close",
                        on: { click: _vm.clearSearchQueryAndCloseMobileNav }
                      })
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c("transition", { attrs: { name: "fade" } }, [
              _vm.$store.state.recentSearches.length > 0
                ? _c(
                    "section",
                    { staticClass: "recents" },
                    [
                      _c("span", [_vm._v("Recent")]),
                      _vm._v(" "),
                      _c(
                        "transition-group",
                        {
                          staticClass: "recents__list",
                          attrs: { name: "fade", tag: "ul" }
                        },
                        _vm._l(_vm.$store.state.recentSearches, function(
                          search,
                          index
                        ) {
                          return _c(
                            "li",
                            {
                              key: _vm.makeSearchItemKey(search),
                              staticClass: "recents__search"
                            },
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "link",
                                  attrs: {
                                    title: search.label,
                                    to: _vm.fixPath(search.route)
                                  },
                                  nativeOn: {
                                    click: function($event) {
                                      _vm.onRecentSearchClick(search)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(search.label))]
                              ),
                              _vm._v(" "),
                              _c("button", {
                                staticClass: "icon-cancel",
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    _vm.removeRecentSearchAt(index)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        })
                      )
                    ],
                    1
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("transition", { attrs: { name: "slide-fade" } }, [
              _vm.isMobileNavOpen
                ? _c("section", { staticClass: "mobile-nav" }, [
                    _vm.activeSubcategory
                      ? _c(
                          "h3",
                          {
                            staticClass:
                              "mobile-nav__nav-element mobile-nav__nav-header",
                            attrs: {
                              "data-e2e": "site-header.mobile-nav.subcategory"
                            },
                            on: {
                              click: function($event) {
                                _vm.setActiveCategory(_vm.highlights[0])
                              }
                            }
                          },
                          [
                            _c("span", {
                              staticClass:
                                "icon-chevron-lg-left mobile-nav__icon"
                            }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(_vm.activeSubcategory.name))
                            ])
                          ]
                        )
                      : _vm.activeCategory
                      ? _c(
                          "h3",
                          {
                            staticClass:
                              "mobile-nav__nav-element mobile-nav__nav-header",
                            attrs: {
                              "data-e2e": "site-header.mobile-nav.subcategory"
                            },
                            on: {
                              click: function($event) {
                                _vm.setActiveCategory(null)
                              }
                            }
                          },
                          [
                            _c("span", {
                              staticClass:
                                "icon-chevron-lg-left mobile-nav__icon"
                            }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(_vm.activeCategory.name))
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.activeCategory
                      ? _c(
                          "ul",
                          {
                            staticClass: "mobile-nav__categories",
                            attrs: {
                              "data-e2e": "site-header.mobile-nav.categories"
                            }
                          },
                          _vm._l(_vm.highlights, function(category, index) {
                            return _c(
                              "li",
                              {
                                key: category.name,
                                staticClass:
                                  "mobile-nav__nav-element mobile-nav__nav-header--uncollapsed",
                                attrs: {
                                  "data-e2e":
                                    "site-header.mobile-nav.category-" + index
                                },
                                on: {
                                  click: function($event) {
                                    _vm.setActiveCategory(category)
                                  }
                                }
                              },
                              [
                                _c("span", [_vm._v(_vm._s(category.name))]),
                                _vm._v(" "),
                                _c("span", {
                                  staticClass: "icon-chevron-lg-right"
                                })
                              ]
                            )
                          })
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.activeSubcategory
                      ? _c(
                          "ul",
                          {
                            staticClass: "mobile-nav__subcategories",
                            attrs: {
                              "data-e2e": "site-header.mobile-nav.leagues"
                            }
                          },
                          _vm._l(_vm.subcategories, function(
                            subcategory,
                            index
                          ) {
                            return _c(
                              "li",
                              {
                                key: subcategory.name,
                                staticClass: "mobile-nav__nav-element",
                                attrs: {
                                  "data-e2e":
                                    "site-header.mobile-nav.league-" + index
                                },
                                on: {
                                  click: function($event) {
                                    _vm.setActiveSubcategory(subcategory)
                                  }
                                }
                              },
                              [
                                _c("span", [_vm._v(_vm._s(subcategory.name))]),
                                _vm._v(" "),
                                _c("span", {
                                  staticClass: "icon-chevron-lg-right"
                                })
                              ]
                            )
                          })
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "ul",
                      {
                        staticClass: "mobile-nav__performers",
                        attrs: {
                          "data-e2e": "site-header.mobile-nav.performers"
                        }
                      },
                      [
                        (_vm.activeSubcategory || {}).slug
                          ? _c(
                              "li",
                              [
                                _c(
                                  "router-link",
                                  {
                                    staticClass:
                                      "mobile-nav__nav-element mobile-nav__router",
                                    attrs: {
                                      to: _vm.fixPath(
                                        _vm.activeSubcategory.slug
                                      )
                                    }
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        "All " +
                                          _vm._s(_vm.activeSubcategory.name)
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("span", {
                                      staticClass: "icon-chevron-lg-right"
                                    })
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.activeCategory &&
                        _vm.activeCategory.id === "exclusive"
                          ? [
                              _c(
                                "li",
                                {
                                  attrs: {
                                    "data-e2e":
                                      "site-header.mobile-nav.performer-3"
                                  }
                                },
                                [
                                  _c(
                                    "router-link",
                                    {
                                      staticClass:
                                        "mobile-nav__nav-element mobile-nav__router",
                                      attrs: {
                                        to: _vm.fixPath(_vm.results[3].slug)
                                      }
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(_vm._s(_vm.results[3].name))
                                      ]),
                                      _vm._v(" "),
                                      _c("span", {
                                        staticClass: "icon-chevron-lg-right"
                                      })
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm._l(_vm.results.slice(0, 3), function(
                                category,
                                index
                              ) {
                                return _c(
                                  "li",
                                  {
                                    key: category.name,
                                    attrs: {
                                      "data-e2e":
                                        "site-header.mobile-nav.performer-" +
                                        index
                                    }
                                  },
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        staticClass:
                                          "mobile-nav__nav-element mobile-nav__router",
                                        attrs: {
                                          to: _vm.fixPath(category.slug)
                                        }
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(_vm._s(category.name))
                                        ]),
                                        _vm._v(" "),
                                        _c("span", {
                                          staticClass: "icon-chevron-lg-right"
                                        })
                                      ]
                                    )
                                  ],
                                  1
                                )
                              })
                            ]
                          : _vm._l(_vm.results, function(category, index) {
                              return _c(
                                "li",
                                {
                                  key: category.name,
                                  attrs: {
                                    "data-e2e":
                                      "site-header.mobile-nav.performer-" +
                                      index
                                  }
                                },
                                [
                                  _c(
                                    "router-link",
                                    {
                                      staticClass:
                                        "mobile-nav__nav-element mobile-nav__router",
                                      attrs: {
                                        to: _vm.$store.state.selectedLocation
                                          ? _vm.fixPath(
                                              category.slug +
                                                "?lat=" +
                                                _vm.$store.state
                                                  .selectedLocation.latitude +
                                                "&lon=" +
                                                _vm.$store.state
                                                  .selectedLocation.longitude +
                                                "&location_id=" +
                                                _vm.$store.state
                                                  .selectedLocation.id
                                            )
                                          : _vm.fixPath(category.slug)
                                      }
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(_vm._s(category.name))
                                      ]),
                                      _vm._v(" "),
                                      _c("span", {
                                        staticClass: "icon-chevron-lg-right"
                                      })
                                    ]
                                  )
                                ],
                                1
                              )
                            })
                      ],
                      2
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c(
              "transition",
              { attrs: { name: "slide-fade" } },
              [
                _c("search-suggestions", {
                  attrs: {
                    "highlighted-suggestion": _vm.highlightedSuggestion,
                    "make-entity-route": _vm.makeEntityRoute,
                    "on-suggestion-click": _vm.onSuggestionClick,
                    suggestions: _vm.suggestions
                  }
                })
              ],
              1
            )
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.isShowBulletin && _vm.bulletin && _vm.bulletin.message
      ? _c(
          "section",
          { staticClass: "bulletin" },
          [
            _vm.bulletin.legal
              ? _c(
                  "router-link",
                  {
                    staticClass: "bulletin__inner",
                    attrs: {
                      to: {
                        query: _vm.updateQueryParams(_vm.$route.query, {
                          modal: "bulletin-legal"
                        })
                      }
                    },
                    nativeOn: {
                      click: function($event) {
                        return _vm.onClickBulletin($event)
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "bulletin__content",
                        class: { "bulletin__content--fluid": _vm.isFluid }
                      },
                      [
                        _c("div", { staticClass: "bulletin__message" }, [
                          _vm._v(_vm._s(_vm.bulletin.message))
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "bulletin__expiry" }, [
                          _vm.bulletin.expiry
                            ? _c("span", [
                                _vm._v(
                                  "Expires: " +
                                    _vm._s(
                                      _vm.formatDate(
                                        _vm.bulletin.expiry,
                                        "MMMM D, YYYY"
                                      )
                                    ) +
                                    "."
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("span", [_vm._v("Click here for details.")])
                        ])
                      ]
                    )
                  ]
                )
              : _c("div", { staticClass: "bulletin__inner" }, [
                  _c(
                    "div",
                    {
                      staticClass: "bulletin__content",
                      class: { "bulletin__content--fluid": _vm.isFluid }
                    },
                    [
                      _c("div", { staticClass: "bulletin__message" }, [
                        _vm._v(_vm._s(_vm.bulletin.message))
                      ]),
                      _vm._v(" "),
                      _vm.bulletin.expiry
                        ? _c("div", { staticClass: "bulletin__expiry" }, [
                            _vm._v(
                              "\n                        Expires: " +
                                _vm._s(
                                  _vm.formatDate(
                                    _vm.bulletin.expiry,
                                    "MMMM D, YYYY"
                                  )
                                ) +
                                ".\n                    "
                            )
                          ])
                        : _vm._e()
                    ]
                  )
                ])
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h2", [
      _vm._v("Don’t worry, we’ll get you back on track."),
      _c("br"),
      _vm._v("Try searching again.")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }